/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Final_Action_ActivatedInputs */

const en_consumer_declaration_final_action_activated = /** @type {(inputs: Consumer_Declaration_Final_Action_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Final confirmation action activated`)
};

const de_consumer_declaration_final_action_activated = /** @type {(inputs: Consumer_Declaration_Final_Action_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betätigte Bestätigungsfunktion`)
};

const fr_consumer_declaration_final_action_activated = /** @type {(inputs: Consumer_Declaration_Final_Action_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action de confirmation finale activée`)
};

const es_consumer_declaration_final_action_activated = /** @type {(inputs: Consumer_Declaration_Final_Action_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acción de confirmación final activada`)
};

const it_consumer_declaration_final_action_activated = /** @type {(inputs: Consumer_Declaration_Final_Action_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azione di conferma finale attivata`)
};

const nl_consumer_declaration_final_action_activated = /** @type {(inputs: Consumer_Declaration_Final_Action_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geactiveerde definitieve bevestigingsactie`)
};

const pl_consumer_declaration_final_action_activated = /** @type {(inputs: Consumer_Declaration_Final_Action_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktywowana końcowa czynność potwierdzenia`)
};

const fi_consumer_declaration_final_action_activated = /** @type {(inputs: Consumer_Declaration_Final_Action_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivoitu lopullinen vahvistustoiminto`)
};

const da_consumer_declaration_final_action_activated = /** @type {(inputs: Consumer_Declaration_Final_Action_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiveret endelig bekræftelseshandling`)
};

const sv_consumer_declaration_final_action_activated = /** @type {(inputs: Consumer_Declaration_Final_Action_ActivatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiverad slutlig bekräftelseåtgärd`)
};

/**
* | output |
* | --- |
* | "Final confirmation action activated" |
*
* @param {Consumer_Declaration_Final_Action_ActivatedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_final_action_activated = /** @type {((inputs?: Consumer_Declaration_Final_Action_ActivatedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Final_Action_ActivatedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_final_action_activated(inputs)
	if (locale === "fr") return fr_consumer_declaration_final_action_activated(inputs)
	if (locale === "es") return es_consumer_declaration_final_action_activated(inputs)
	if (locale === "it") return it_consumer_declaration_final_action_activated(inputs)
	if (locale === "nl") return nl_consumer_declaration_final_action_activated(inputs)
	if (locale === "pl") return pl_consumer_declaration_final_action_activated(inputs)
	if (locale === "fi") return fi_consumer_declaration_final_action_activated(inputs)
	if (locale === "da") return da_consumer_declaration_final_action_activated(inputs)
	if (locale === "sv") return sv_consumer_declaration_final_action_activated(inputs)
	return en_consumer_declaration_final_action_activated(inputs)
});